import React, { useContext } from "react";
import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import AirportServicesContext from "../../../../../../contexts/AirportServices/AirportServices";
import FlightLandIcon from "@mui/icons-material/FlightLand";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import { useTranslation } from "react-i18next";

export default function RadioButtons() {
  const { t } = useTranslation();

  const { setTravelType, travelType } = useContext(AirportServicesContext);

  const handleChange = (event) => {
    setTravelType(event.target.value);
  };

  return (
    <FormControl>
      <RadioGroup
        aria-labelledby="travel-type-radio-buttons-group-label"
        value={travelType}
        onChange={handleChange}
        name="travel-type-radio-buttons-group"
        sx={{ display: "flex", flexDirection: "row" }}
      >
        <FormControlLabel
          sx={{ color: "#ffffff" }}
          value="Arrival"
          control={
            <Radio
              sx={{
                color: "#ffffff", // Default state color
                "&.Mui-checked": {
                  color: "#ffffff", // Color when radio button is checked
                },
              }}
            />
          }
          label={
            <Box
              display="flex"
              flexDirection={"column"}
              alignItems="flex-start"
            >
              <FlightLandIcon />
              <span style={{ fontSize: "12px", textTransform: 'capitalize' }}>{t("airportTransfer.arrival")}</span>
            </Box>
          }
        />
        <FormControlLabel
          sx={{ color: "#ffffff" }}
          value="Departure"
          control={
            <Radio
              sx={{
                color: "#ffffff", // Default state color
                "&.Mui-checked": {
                  color: "#ffffff", // Color when radio button is checked
                },
              }}
            />
          }
          label={
            <Box
              display="flex"
              flexDirection={"column"}
              alignItems="flex-start"
            >
              <FlightTakeoffIcon />
              <span style={{ fontSize: "12px", textTransform: 'capitalize' }}>{t("airportTransfer.departure")}</span>
            </Box>
          }
        />
      </RadioGroup>
    </FormControl>
  );
}
